module.exports = __webpack_public_path__ + "img/medal.b958bd99.svg";